import React from 'react';
import PropTypes from 'prop-types';
import './TranslucentContainer.scss';

function TranslucentContainer({ children, ...props }) {
  return (
    <div className="translucent-container " {...props}>
      {children}
    </div>
  );
}

TranslucentContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TranslucentContainer;
